import PropTypes from 'prop-types';
import { Typography, makeStyles } from '@material-ui/core';
import { ReactComponent as AiIcon } from '../../../../../assets/icons/auto_awesome.svg';

const useStyles = makeStyles(theme => ({
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.primary.bluish7}`,
    borderRadius: 8,
    backgroundColor: theme.palette.common.white,
  },
  icon: {
    flexShrink: 0,
    width: 16,
    height: 16,
    marginTop: 2,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  label: {
    display: 'block',
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.04em',
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.bluish2,
  },
  text: {
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.primary.bluish3,
    whiteSpace: 'pre-wrap',
  },
}));

const ReasoningBlock = ({ label, text }) => {
  const classes = useStyles();

  if (!text) {
    return null;
  }

  return (
    <div className={classes.row}>
      <AiIcon className={classes.icon} aria-hidden />
      <div className={classes.content}>
        <Typography className={classes.label} component="span">
          {label}
        </Typography>
        <Typography className={classes.text} variant="body2" component="div">
          {text}
        </Typography>
      </div>
    </div>
  );
};

ReasoningBlock.propTypes = {
  label: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default ReasoningBlock;
